import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// §29 — nunca só "Nenhum X encontrado": orienta + oferece ação.
export function EmptyState({ icon, title, description, actions }) {
  return (
    <div className="crm-empty-state">
      {icon && <div className="crm-empty-state-icon"><FontAwesomeIcon icon={icon} /></div>}
      {title && <div className="crm-empty-state-title">{title}</div>}
      {description && <div className="crm-empty-state-description">{description}</div>}
      {actions && <div className="crm-empty-state-actions">{actions}</div>}
    </div>
  );
}

export default EmptyState;
